module.exports = __webpack_public_path__ + "../static/img/mictlan_logo.5ae237aa.png";